export const DEFAULT_PER_PAGE = 10;
export const COMPANIES_FILTER = {
  page: 1,
  perPage: 10,
  is_api: 1
};
export const BLOG_FILTER = {
  page: 1,
  perPage: 11,
  is_api: 1
};
export const OTHER_SERVICE = {
  id: "autre",
  label: "Autre service"
};
